module.exports = __webpack_public_path__ + "static/media/icon_edit_pencil.53f8c8ad.svg";